import { AxiosResponse } from 'axios';
import axiosInstance from '../';
import { ITariff } from '../models/models';

export default class CommonService {
	static getTariffs(): Promise<AxiosResponse<ITariff[]>> {
		return axiosInstance.get('/common/tariffs');
	}
}
